export class AysOperatingRoomIndexItem {

    public static fromObj(obj: any): AysOperatingRoomIndexItem {
        return new AysOperatingRoomIndexItem(
            obj.id,
            obj.name,
            obj.info
        );
    }

    constructor(
        public id: string,
        public name: string,
        public info?: string
    ) {
    }

    public static fromObjArr(objArr: any[]): AysOperatingRoomIndexItem[] {
        return objArr.map(AysOperatingRoomIndexItem.fromObj);
    }
}
